import { render, staticRenderFns } from "./User-static-chart.vue?vue&type=template&id=6d8fbb23&scoped=true&"
import script from "./User-static-chart.vue?vue&type=script&lang=js&"
export * from "./User-static-chart.vue?vue&type=script&lang=js&"
import style0 from "./User-static-chart.vue?vue&type=style&index=0&id=6d8fbb23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8fbb23",
  null
  
)

export default component.exports